/* 年月日時分コントロール */
import React from 'react';
import DatePicker from './DatePicker';
import Messages from '../molecules/Messages';
import { hours, minutes } from './../Const';
var DateTimePicker = function (_a) {
    var id = _a.id, customInput = _a.customInput, selected_ymd = _a.selected_ymd, selected_hour = _a.selected_hour, selected_minute = _a.selected_minute, help_msg = _a.help_msg, message = _a.message, handleChangeDate = _a.handleChangeDate, handleChangeHour = _a.handleChangeHour, handleChangeMinute = _a.handleChangeMinute;
    return (React.createElement("div", { className: "datetimepicker-wrapper" },
        React.createElement("div", null,
            React.createElement(DatePicker, { id: id, handleChangeDate: function (date) { return handleChangeDate(date); }, selected: selected_ymd, customInput: customInput }),
            React.createElement("select", { name: "\u6642", className: "search-form-input-small search-form-time", value: selected_hour, onChange: function (event) {
                    return handleChangeHour(event === null || event === void 0 ? void 0 : event.target.value);
                } },
                React.createElement("option", null), hours === null || hours === void 0 ? void 0 :
                hours.map(function (hour, index) {
                    return (React.createElement("option", { key: index, value: hour }, hour));
                })),
            React.createElement("span", null, ":"),
            React.createElement("select", { name: "\u5206", className: "search-form-input-small search-form-time", value: selected_minute, onChange: function (event) {
                    return handleChangeMinute(event === null || event === void 0 ? void 0 : event.target.value);
                } },
                React.createElement("option", null), minutes === null || minutes === void 0 ? void 0 :
                minutes.map(function (minute, index) {
                    return (React.createElement("option", { key: index, value: minute }, minute));
                }))),
        React.createElement("div", null,
            React.createElement(Messages, { help_msg: help_msg, valid_msg: message }))));
};
export default DateTimePicker;
